import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, filter, catchError, concatMap } from 'rxjs/operators';

import { UserService } from '../../services/user.service';
import {TOKEN, UtilsService} from '../../services/utils.service';
import { User, Response } from '../../models/user';
import * as actions from '../actions';
import * as featureActions from '../../my-features/index';
import { AuthOtpType, AuthOtpDeviceType } from 'src/app/shareModel';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);
  private userService = inject(UserService);
  private utils = inject(UtilsService);

  constructor() {}

  loginEffect$= createEffect(() => this.actions$.pipe(
    ofType(actions.LOGIN),
    map((action: actions.LoginAction) => action.payload),
    switchMap((user: User) => {
      // 創建新對象副本以避免修改只讀的 action payload (NgRx 8/9 immutability)
      const sanitizedUser = { ...user, username: user.username.replace(/\s+/g, '') };
      return this.userService.loginServer(sanitizedUser).pipe(
        map((res: Response) => {
          if (res.Flag) {
            const token = JSON.parse(this.utils.getToken());
            // EnableOtp 雙因驗證
            if (res.EnableOtp) {
              const param = {
                otp: res.OtpKey,
                DeviceType: AuthOtpDeviceType.Web,
                AuthType: AuthOtpType.Login,
              };
              this.utils.writeToken({...token,
                userToken: res.token
              });
              return new featureActions.AddAuthOtp(param);

            } else {
              // if (user.rememberMe) {
              this.utils.writeToken({...token,
                value: res.OtpKey,
                timestamp: new Date().getTime(),
                username: res.Account,
                acode: Number(res.acode),
                RegionId: res.RegionId,
                Package: res.Package,
                IsMsp: res.IsMsp,
                userToken: res.token
              });
              // }
              return new actions.LoginSuccessAction({
                username: res.Account,
                OtpKey: res.OtpKey,
                acode: Number(res.acode),
                RegionId: res.RegionId,
                Package: res.Package,
                IsMsp: res.IsMsp,
                ProStatus: res.ProStatus
              });
            }
          } else {
            return new actions.LoginFailAction(res);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((err) => of(new actions.LoginFailAction(err))),
      );
    }),
  ));
  logoutEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.LOGOUT),
    map(() => {
      const jwtStr = this.utils.getToken(TOKEN);
      let token: any;
      if (jwtStr) {
        token = JSON.parse(jwtStr);
      }
      return token;
    }),
    switchMap((token: any) => {
      if (token && token.value) {
        return this.userService.logoutServer(token.value).pipe(
          switchMap((res: any) => {
              this.utils.removeToken();
              const obj = {ssocookie: null, ssouser: null};
              if (token.ssocookie) {
                obj.ssocookie = token.ssocookie;
              }
              if (token.ssouser) {
                obj.ssouser = token.ssouser;
              }
              this.utils.writeToken(obj);
              return [new actions.LogoutSuccessAction(),
                      new actions.ClearDeviceInfoAction(),
                      new actions.ClearDevicesStatusAction()];
              // return [new actions.LogoutSuccessAction()];
          }),
          // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError((err) => of(new actions.LogoutFailAction())),
        );
      } else {
        console.log('log out success without otp');
        this.utils.removeToken();
        return of((new actions.LogoutSuccessAction()));
      }
    }),
  ));
  getUserEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.GETUSER),
    concatMap(() => {
      return this.userService.getCurrentUser().pipe(
        filter(user => (user !== null)),
        map((user: User) => new actions.GetUserSuccessAction(user)),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(err => of(new actions.GetUserFailAction(err))),
      );
    })
  ));
}
